import { render } from "./xtx-tabs-panel.vue?vue&type=template&id=0188376d"
import script from "./xtx-tabs-panel.vue?vue&type=script&lang=js"
export * from "./xtx-tabs-panel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__